var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExaminationCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.625C2.89453 0.625 0 3.54492 0 7.125C0 10.7305 2.89453 13.625 6.5 13.625C10.0801 13.625 13 10.7305 13 7.125C13 3.54492 10.0801 0.625 6.5 0.625ZM5.89062 4.48438C5.89062 4.1543 6.14453 3.875 6.5 3.875C6.83008 3.875 7.10938 4.1543 7.10938 4.48438V7.73438C7.10938 8.08984 6.83008 8.34375 6.5 8.34375C6.14453 8.34375 5.89062 8.08984 5.89062 7.73438V4.48438ZM6.5 10.7812C6.04297 10.7812 5.6875 10.4258 5.6875 9.99414C5.6875 9.5625 6.04297 9.20703 6.5 9.20703C6.93164 9.20703 7.28711 9.5625 7.28711 9.99414C7.28711 10.4258 6.93164 10.7812 6.5 10.7812Z",
    fill: "#FF6347"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExaminationCircleIcon);
export default __webpack_public_path__ + "static/media/examination-circle-icon.454f3f4dfb66037f8f6f909f76dfa291.svg";
export { ForwardRef as ReactComponent };